/** Footer button chrome for question cards, per the Figma card spec (node 1220:606): a hairline
 * 0.5px border and tertiary label, where Kakashi's secondary variant ships a 1px border and a
 * darker (#57524D) label. Applied as a className override so the geometry still comes from
 * Kakashi's `sm` size, which already matches the design's 6px/8px padding and 6px radius. */
export const QUESTION_CARD_SECONDARY_BUTTON =
  'border-[0.5px] border-border-tertiary text-text-tertiary';
